import { useEffect, useState } from 'react';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';
import { RoleService } from '../../services/role/roleService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage roles fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de roles.
----------------------------------------------------------------------------------------*/

const useRoles = (initialFilters = {}) => {
    // STATES
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { userCan } = usePrivilege();
    let filters = {
        limit: 999999,
        filter_filters: { ...initialFilters }
    };

    const fetchData = async (f?: any) => {
        if (!userCan('list', 'role')) return;
        const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
        setLoading(true);
        try {
            const response = await (new RoleService()).listSelectRoles(newFilters);
            const fetchedData = response.getResponseData();
            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; companyName: string; }) => ({
                    value: data.id,
                    label: userCan('list', 'role') && data.companyName ? `${data.name} (${data.companyName})` : data.name,
                }));
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching roles:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    const getRolesList = (entity?: string | null, notShowStatusID?: Array<string> | null, notShowStatusName?: Array<string> | null) => {
        let dataCopy = [...data];
        if (entity) return dataCopy.filter((state: any) => state.entity === entity);
        if (notShowStatusID && Array.isArray(notShowStatusID)) dataCopy = dataCopy.filter((state: any) => !notShowStatusID.includes(state.value));
        if (notShowStatusName && Array.isArray(notShowStatusName)) dataCopy = dataCopy.filter((state: any) => !notShowStatusName.includes(state.label));
        return dataCopy;
    };

    return { fetchRoles: fetchData, getRolesList };
}

export default useRoles;